
// For Callcenter and Customer For Live

const BASE_URL = "https://retailportalapi.webddocsystems.com/";
const ChargingBASE_URL = "https://chargingapi.webddocsystems.com/";
const paybridge_Url = "https://paybridge-backend.webddocsystems.com/api/";
// Default RSA activate (non-RSASALE companies / productType RSA via kz)
const RSA_ACTIVATE_URL =
	'https://kz.webddocsystems.com/RetailApi/v1/ActivateRSAfromPortalUpdate';


//// For Finance and Reversal Testing

 //const BASE_URL = "http://localhost:5045/";
// const ChargingBASE_URL = "https://localhost:7244/";
// const paybridge_Url = "http://localhost:5000/api/";

/** RSASALE companies use portal API; everyone else keeps kz URL. */
const getRsaActivateUrl = (isRsaSaleCompany = false) =>
	isRsaSaleCompany
		? `${BASE_URL}ActivateRSAfromPortalUpdate`
		: RSA_ACTIVATE_URL;

export { BASE_URL, ChargingBASE_URL, paybridge_Url, RSA_ACTIVATE_URL, getRsaActivateUrl };
